// Настенное время компании — фрейм, в котором живут ДАТЫ БРОНЕЙ.
//
// Бэкенд хранит их особым образом: `bookings.start_date` — строка "29-07-2026 18:00", а
// `start_date_formatted` = `String#to_datetime` от неё. `to_datetime` игнорирует зону и
// подставляет +00:00, поэтому в API такие поля приходят как "2026-07-29T18:00:00.000Z",
// где 18:00 — часы на стене у компании, а НЕ инстант. Всё остальное (created_at, due_at
// задач и т.п.) — настоящие инстанты, к ним эти хелперы не применять.
//
// Большая часть экранов работает со строковыми полями и парсит их как локальные
// (`moment(booking.start_date, "DD-MM-YYYY H:mm")`) — это тот же фрейм. Хелперы ниже нужны
// там, где API отдаёт datetime (доска автомобилей, FT-087).
import moment from "moment";

// "2026-07-29T18:00:00.000Z" → moment с ТЕМИ ЖЕ настенными компонентами в поясе браузера.
// Печать такого момента не зависит от пояса браузера — это и требуется для дат броней.
export function wallClock(value) {
  if (value === null || value === undefined || value === "") return null;
  return moment.utc(value).local(true);
}

// «Сейчас» на часах компании в том же фрейме, что и wallClock(): берём текущие настенные
// компоненты в поясе компании и читаем их как локальные. Сравнивать даты броней надо именно
// с ним, а не с moment(): сотрудник может открыть страницу из другого пояса.
//
// timeZone — IANA-имя из настроек компании (companies.time_zone). Без него (или при
// неизвестной зоне) возвращаем часы браузера — прежнее поведение, ничего не ломаем.
// now — точка отсчёта, параметр только ради тестируемости.
export function companyNow(timeZone, now = new Date()) {
  if (!timeZone) return moment(now);
  let parts;
  try {
    // sv-SE даёт "YYYY-MM-DD HH:mm:ss" — единственная локаль с ISO-подобным порядком.
    parts = new Intl.DateTimeFormat("sv-SE", {
      timeZone,
      year: "numeric", month: "2-digit", day: "2-digit",
      hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false,
    }).format(now);
  } catch (e) {
    // Неизвестная зона в настройках не должна ронять экран.
    return moment(now);
  }
  return moment(parts, "YYYY-MM-DD HH:mm:ss");
}

// Прошло ли настенное время брони по часам компании (просрочка возврата и т.п.).
export function isWallClockPast(value, timeZone, now = new Date()) {
  const at = wallClock(value);
  return !!at && at.isBefore(companyNow(timeZone, now));
}
